(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var _pushState = history.pushState;
    history.pushState = function() {
      _pushState.apply(this, arguments);
      window.dispatchEvent(new Event('nav:change'));
    };
  })();

  document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.header__menu-toggle');
    const mobileMenu = document.querySelector('.header__mobile-menu');

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', !isExpanded);
        mobileMenu.classList.toggle('is-open');
      });

      mobileMenu.querySelectorAll('a').forEach(function(link) {
        link.addEventListener('click', function() {
          menuToggle.setAttribute('aria-expanded', 'false');
          mobileMenu.classList.remove('is-open');
        });
      });
    }

    function updateActiveLinks() {
      var currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

      if (menuToggle && mobileMenu) {
        menuToggle.setAttribute('aria-expanded', 'false');
        mobileMenu.classList.remove('is-open');

        mobileMenu.querySelectorAll('[data-mobile-nav]').forEach(function(a) {
          var linkPath = a.pathname.replace(/\/+$/, '') || '/';
          var isActive = (linkPath === currentPath) ||
            (currentPath !== '/' && linkPath !== '/' && currentPath.indexOf(linkPath) === 0);
          if (isActive) {
            a.classList.add('is-active-page');
          } else {
            a.classList.remove('is-active-page');
          }
        });
      }

      document.querySelectorAll('.header__nav-link').forEach(function(a) {
        var linkPath = a.pathname.replace(/\/+$/, '') || '/';
        var isActive = (linkPath === currentPath) ||
          (currentPath !== '/' && linkPath !== '/' && currentPath.indexOf(linkPath) === 0);
        if (isActive) {
          a.classList.add('header__nav-link--active');
        } else {
          a.classList.remove('header__nav-link--active');
        }
      });
    }

    updateActiveLinks();
    window.addEventListener('pageshow', updateActiveLinks);
    window.addEventListener('popstate', updateActiveLinks);
    window.addEventListener('nav:change', updateActiveLinks);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-different"] && !Shopify.designMode) return;
  try {
    
  class OurStoryBenefitsCarousel extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-initialized')) return;

      this.setAttribute('data-initialized', 'true');
      this.scroller = this.querySelector('.our-story-different__grid--mobile');
      this.previousButton = this.querySelector('[data-carousel-previous]');
      this.nextButton = this.querySelector('[data-carousel-next]');

      if (!this.scroller || !this.previousButton || !this.nextButton) return;

      this.handlePrevious = () => this.scrollByCard(-1);
      this.handleNext = () => this.scrollByCard(1);
      this.handleScroll = () => {
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = window.requestAnimationFrame(() => this.updateButtons());
      };

      this.previousButton.addEventListener('click', this.handlePrevious);
      this.nextButton.addEventListener('click', this.handleNext);
      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.scroller);
      this.updateButtons();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.scroller?.removeEventListener('scroll', this.handleScroll);
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.scrollFrame);
      this.removeAttribute('data-initialized');
    }

    scrollByCard(direction) {
      const card = this.scroller.querySelector('.our-story-different__item--scroll');
      if (!card) return;

      const styles = window.getComputedStyle(this.scroller);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      this.scroller.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: 'smooth',
      });
    }

    updateButtons() {
      const maximumScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
      this.previousButton.disabled = this.scroller.scrollLeft <= 2;
      this.nextButton.disabled = this.scroller.scrollLeft >= maximumScroll - 2;
    }
  }

  if (!customElements.get('our-story-benefits-carousel')) {
    customElements.define('our-story-benefits-carousel', OurStoryBenefitsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  if (!customElements.get('product-purchase')) {
    customElements.define('product-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.variantListener) return;
        this.variantListener = (event) => {
          if (!event.target.matches('[data-variant-select]')) return;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', event.target.value);
          url.searchParams.delete('selling_plan');
          window.location.assign(url.toString());
        };
        this.addEventListener('change', this.variantListener);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.variantListener);
        this.variantListener = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
